import React, {useEffect, useState} from "react";
import API from "../../../apiService";

const ExternalIntraOral = ({visit_id, onDataChange}) => {

    const [wajah, setWajah] = useState('Simetris')
    const [limfe, setLimfe] = useState('Tidak')
    const [lain, setLain] = useState('')
    const [gigi, setGigi] = useState('')
    const [mukosa, setMukosa] = useState('')
    const [lidah, setLidah] = useState('')

    useEffect(() => {
        onDataChange({wajah, limfe, lain, gigi, mukosa, lidah})
    }, [wajah, limfe, lain, gigi, mukosa, lidah])

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const r = await API.get(`/management/teeth_external_intra_oral/visit/${visit_id}`)
        if (r.code === 200) {
            const v = r.data
            setWajah(v.wajah)
            setLimfe(v.limfe)
            setLain(v.lain)
            setGigi(v.gigi)
            setMukosa(v.mukosa)
            setLidah(v.lidah)
        }
    }

    return (
        <>
            <h3>EO (Eksternal Oral):</h3>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Wajah
                </label>
                <div className="col-md-7">
                    <div className="custom-control custom-radio mr-3 d-inline-block">
                        <input className="custom-control-input"
                               id={`wajah1`}
                               type="radio"
                               checked={wajah === 'Simetris'}
                               onChange={(e) => {
                                   setWajah('Simetris')
                               }}
                        />
                        <label className="custom-control-label" htmlFor={`wajah1`}>Simetris</label>
                    </div>
                    <div className="custom-control custom-radio mr-3 d-inline-block">
                        <input className="custom-control-input"
                               id={`wajah2`}
                               type="radio"
                               checked={wajah === 'Asimetris'}
                               onChange={(e) => {
                                   setWajah('Asimetris')
                               }}
                        />
                        <label className="custom-control-label" htmlFor={`wajah2`}>Asimetris</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Kel. Limfe
                </label>
                <div className="col-md-7">
                    <div className="custom-control custom-radio mr-3 d-inline-block">
                        <input className="custom-control-input"
                               id={`limfe1`}
                               type="radio"
                               checked={limfe === 'Tidak'}
                               onChange={(e) => {
                                   setLimfe('Tidak')
                               }}
                        />
                        <label className="custom-control-label" htmlFor={`limfe1`}>Tidak</label>
                    </div>
                    <div className="custom-control custom-radio mr-3 d-inline-block">
                        <input className="custom-control-input"
                               id={`limfe2`}
                               type="radio"
                               checked={limfe === 'Teraba'}
                               onChange={(e) => {
                                   setLimfe('Teraba')
                               }}
                        />
                        <label className="custom-control-label" htmlFor={`limfe2`}>Teraba</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Lain-lain
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm col-sm-12"
                            onChange={e => setLain(e.target.value)}
                            value={lain}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
            <h3>IO (Intra Oral):</h3>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Gigi
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm col-sm-12"
                            onChange={e => setGigi(e.target.value)}
                            value={gigi}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Mukosa/Gingiva
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm col-sm-12"
                            onChange={e => setMukosa(e.target.value)}
                            value={mukosa}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
            <div className="row">
                <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                >
                    Lidah/Palatum
                </label>
                <div className="col-md-7">
                    <div className="row">
                        <textarea
                            className="form-control form-control-sm col-sm-12"
                            onChange={e => setLidah(e.target.value)}
                            value={lidah}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExternalIntraOral